import React from "react";
import "./About.css";
import MarketsHeaderImg from "../assets/markets-header.jpg";
import marketImg1 from "../assets/markets-1.png";
import marketImg2 from "../assets/markets-2.png";
import marketImg3 from "../assets/markets-3.JPG";
import marketsRHK from "../assets/markets_RHK.png";
import PageHeader from "../components/PageHeader";
import TextPic from "../components/TextPic";
import PicText from "../components/PicText";

const PageTitle = "Advanced Cathodes to Meet Market Needs";
const SubTitle =
  "Sampling and Testing LXMO™ with major players in the Li-Ion supply chain ";
const SubContent = `
        Stratus has been sampling and validating its advanced LXMO cathode
        materials with external end-users and partners since the first quarter
        of 2023. This broad set of industry players evaluating LXMO continues 
        to expand and includes many leading EV OEMs, major Li-Ion cell and pack 
        producers, as well as established CAM manufacturers. Stratus is also 
        engaged with battery partners targeting stationary energy storage, 
        consumer electronics, and defense/specialty applications.`;

const title1 = "Full Format Validation";
const content1 = `
        To date, LXMO has been built and evaluated in many pouch cell formats between 
        100 mAh and 6 Ah. Early in 2025, Stratus also started building multiple types 
        of larger pouch cells between 15 and 25 Ah. These cell builds demonstrate LXMO's 
        performance and scalability for potential use in high-capacity energy storage 
        systems.
        Recent full pouch cells have been demonstrating over 700 Wh/l and 300 Wh/kg.`;
const title2 = "LXMO Supply";
const content2 = `Since early 2023, Stratus has been producing its novel cathode 
        materials on a 1-ton per year pre-pilot production line in Pittsburgh.  
        We are currently in the final stages of standing up a new, 30+ ton per year pilot 
        line that will be operational by the end of 2025.  This additional capacity 
        will provide more LXMO material for external sampling and also validate 
        the scalability of the Stratus manufacturing processes.`;

const title3 = "Learn More";
const content3 = `If your company is interested in learning more about Stratus’s 
        LXMO cathode materials, please contact us at info@stratusmaterials.com`;

function Markets() {
  return (
    <div>
      <PageHeader
        PageTitle={PageTitle}
        SubTitle={SubTitle}
        SubContent={SubContent}
        BackgroundImage={MarketsHeaderImg}
      />

      <TextPic
        title={title1}
        content={content1}
        img={marketImg1}
        height="450px"
      />

      <div
        className="container my-5"
        style={{ backgroundColor: "#EDEEF0", padding: "30px" }}
      >
        <div className="row">
          <div className="col-lg-6 col-md-12 d-flex justify-content-center align-items-center">
            <img
              src={marketImg2}
              alt="img"
              style={{ width: "100%", height: "auto" }}
            />
          </div>
          <div
            className="col-lg-6 col-md-12 d-flex flex-column justify-content-center"
            style={{ height: "auto" }}
          >
            <p
              className="display-6 fw lh-sm mx-3"
              style={{
                color: "#003561",
                fontSize: "2rem",
                fontFamily: "Montserrat",
                fontWeight: "800",
                marginTop: "1rem",
              }}
            >
              {title2}
            </p>

            <p
              className="display-6 fw lh-sm mx-3"
              style={{
                color: "#003561",
                fontSize: "1.7rem",
                fontFamily: "Montserrat",
                fontWeight: "800",
                marginBottom: "1.5rem",
              }}
            >
              <i>Moving to Pilot Volumes</i>
            </p>

            <p
              className="display-6 fw lh-sm mx-3"
              style={{
                color: "#003561",
                fontSize: "1.4rem",
                fontFamily: "Montserrat",
                fontWeight: "400",
              }}
            >
              {content2}
            </p>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 d-flex justify-content-center">
            <img
              src={marketsRHK}
              alt="RHK"
              style={{ width: "100%", height: "auto", maxWidth: "100%" }}
            />
          </div>
        </div>
      </div>

      <div
        className="container my-5"
        style={{ backgroundColor: "#EDEEF0", padding: "30px" }}
      >
        <div className="row">
          <div
            className="col-lg-6 col-md-12 d-flex flex-column justify-content-center"
            style={{ height: "auto" }} // Make height auto for smaller screens
          >
            <p
              className="display-6 fw lh-sm mx-3"
              style={{
                color: "#003561",
                fontSize: "2rem", // Default for large screens
                fontFamily: "'Montserrat'",
                fontWeight: "800",
                marginBottom: "1.5rem", // Reduced margin for better spacing
                marginTop: "1.5rem",
              }}
            >
              {title3}
            </p>
            <p
              className="display-6 fw lh-sm mx-3"
              style={{
                color: "#003561",
                fontSize: "1.4rem",
                fontFamily: "Montserrat",
                fontWeight: "400",
              }}
            >
              If your company is interested in exploring Stratus’s LXMO cathode
              materials and how they can benefit your business needs, please
              contact us at
              <br />
              <br />
              <a href="mailto:info@stratusmaterials.com">
                info@stratusmaterials.com
              </a>
            </p>
          </div>

          <div className="col-lg-6 col-md-12 d-flex justify-content-center align-items-center">
            <img
              src={marketImg3}
              alt="img"
              style={{ width: "100%", height: "auto" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Markets;
